export default "__VITE_ASSET__DwurX5vR__"